import IssuerListContainer from '../helpers/IssuerListContainer';

class OnlineBankingPL extends IssuerListContainer {
    public static type = 'onlineBanking_PL';
}

export default OnlineBankingPL;
